import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'odl-rapportino-mod5',
    templateUrl: './print-rapportino-mod5.component.html',
    styleUrls: ['./print-rapportino-mod5.component.scss']
})
export class PrintRapportinoMod5Component implements OnInit {
    @Input() data: { ordine: any, commessa: any }
    constructor() { }

    ngOnInit() {
    }

}
